import { render, staticRenderFns } from "./Testimoniald.vue?vue&type=template&id=6340ae92&"
import script from "./Testimoniald.vue?vue&type=script&lang=js&"
export * from "./Testimoniald.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports